import React, { PureComponent } from 'react';

export interface Props {
  isVisible: boolean;
  timeoutTimer?: number;
  onHide?(): void;
  children?: React.ReactNode;
}

interface State {
  isVisible: boolean;
}

class FlashMessage extends PureComponent<Props, State> {
  static readonly defaultProps = {
    timeoutTimer: 1500,
  };
  savedTimeout: number | null;

  constructor(props) {
    super(props);
    this.state = { isVisible: props.isVisible };
    this.savedTimeout = null;

    if (props.isVisible) {
      this.setTimeoutToHideMessage();
    }
  }

  componentWillUnmount() {
    this.clearTimeoutIfExists();
  }

  clearTimeoutIfExists() {
    if (this.savedTimeout) {
      clearTimeout(this.savedTimeout);
      this.savedTimeout = null;
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.isVisible && !prevProps.isVisible) {
      this.setState({ isVisible: true });
      this.setTimeoutToHideMessage();
    } else if (!this.props.isVisible && prevProps.isVisible) {
      this.setState({ isVisible: false });
      this.clearTimeoutIfExists();
    }
  }

  setTimeoutToHideMessage() {
    this.clearTimeoutIfExists();
    this.savedTimeout = setTimeout(this.hide, this.props.timeoutTimer);
  }

  hide = () => {
    this.setState({ isVisible: false });
    if (this.props.onHide) {
      this.props.onHide();
    }
  };

  render() {
    return this.state.isVisible ? this.props.children : null;
  }
}

export default FlashMessage;
